import React from "react";
import Spinner from "react-activity/dist/Spinner";

const Overlay = ({showloader}) => {
    return (
        <>
            {
                showloader ?
                <>
                    <div className="overlay-main mobhide">
                    <Spinner color='#f8a41a' size={40} className='spinnerCenter1' />
                </div>
                <div className="overlay-main deskhide">
                    <Spinner color='#f8a41a' size={20} className='spinnerCenter1' />
                </div>
                </>
                 : null
            }
        </>
    )
}

export default Overlay;